import { render, staticRenderFns } from "./AboutCourse.vue?vue&type=template&id=acf01b62"
import script from "./AboutCourse.vue?vue&type=script&lang=js"
export * from "./AboutCourse.vue?vue&type=script&lang=js"
import style0 from "./AboutCourse.vue?vue&type=style&index=0&id=acf01b62&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports